import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseDialog, {
      "is-open": _ctx.showDeleteList,
      "onUpdate:is-open": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showDeleteList) = $event)),
      title: _ctx.labels.deletingList,
      description: _ctx.labels.deleteConfirmText,
      "cancel-button": _ctx.labels.cancelDeleteBtn,
      "confirm-button": _ctx.labels.deleteConfirmBtn,
      "confirm-method": _ctx.deleteList
    }, null, 8, ["is-open", "title", "description", "cancel-button", "confirm-button", "confirm-method"]),
    _createElementVNode("button", {
      class: "c-magic-line text-dusty-grey",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showDeleteList = true), ["prevent"]))
    }, _toDisplayString(_ctx.labels.deleteListBtn), 1)
  ], 64))
}